import React, { useState, useEffect, useMemo, useRef } from "react";
import "@styles/App.scss";
import { useDispatch, useSelector } from "react-redux";
import { Trans, useTranslation } from "react-i18next";
import {
  Routes,
  Route,
  useNavigate,
  useLocation,
  useSearchParams,
} from "react-router-dom";
import ProtectedRoute from "@components/router/ProtectedRoute";
import RedirectIfAuthenticated from "@components/router/RedirectIfAuthenticated";
import ScrollToTop from "@components/router/ScrollToTop";
import NavigationBar from "@components/ui/NavigationBar";
import Footer from "@components/ui/Footer";
import Home from "@pages/Home";
import EventForm from "@pages/EventForm";
import Inquiry from "@pages/Inquiry";
import MemberZone from "@pages/MemberZone";
import EarnSDollar from "@pages/EarnSDollar";
import Redeem from "@pages/Redeem";
import EventSummaryPage from "@pages/EventForm/summary/EventSummaryPage";
import VideoBlogSummaryPage from "@pages/GenericPage/VideoBlogSummaryPage/";
import VideoSummaryPage from "@pages/GenericPage/VideoBlogSummaryPage/VideoSummaryPage";
import BlogSummaryPage from "@pages/GenericPage/VideoBlogSummaryPage/BlogSummaryPage";
import BlogArticlePage from "@pages/GenericPage/BlogArticlePage";
import Login from "@pages/Login";
import OnlyClubsLogin from "@pages/Login/OnlyClubsLogin";
import OnlySamsungAccountLogin from "@pages/Login/OnlySamsungAccountLogin";
import AfterSamsungAccountLogin from "@pages/Login/Samsung/AfterSamsungAccountLogin";
import NotFound from "@pages/ErrorPage/NotFound";
import IsLinked from "@pages/ErrorPage/IsLinked";
import ForgetPassword from "@pages/Login/Password/ForgetPassword";
import ResetPassword from "@pages/Login/Password/ResetPassword";
import TncPage from "@pages/GenericPage/TncPage";
import FaqPage from "@pages/GenericPage/FaqPage";
import EventRegistrationLanding from "@pages/EventForm/EventRegistrationLanding";
import FloatingBtn from "@components/ui/FloatingBtn";

import {
  Box,
  ThemeProvider,
  Typography,
  Button,
  LinearProgress,
} from "@mui/material";
import theme from "./theme";
import { ToastContainer, Bounce } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useAuthSync from "@hooks/useAuthSync";
import PageLoader from "@components/ui/PageLoader";
import Popup from "reactjs-popup";
import { redirectToSamsungLoginPage } from "@utils/redirectToSamsungLoginPage";
import ErrorIcon from "@mui/icons-material/Error";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { editMemberProfile } from "@api/memberApi";
import { updatePopupCount } from "@api/commonApi";
import { toast } from "react-toastify";
import { set } from "date-fns";
import { m } from "framer-motion";

const App = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const utm_id = searchParams.get("utm_id");

    if (utm_id) {
      localStorage.setItem("utm_id", utm_id);
    }
  }, [searchParams]);

  const utmId = localStorage.getItem("utm_id");

  const { t, i18n } = useTranslation();
  const { loading } = useAuthSync();
  const [showLoader, setShowLoader] = useState(true);
  const [loaderVisible, setLoaderVisible] = useState(true); // 控制 fade
  const [openPopup, setOpenPopup] = useState(false);
  const [redirectToLinkUpProgress, setRedirectToLinkUpProgress] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isShowfloatingButton, seTisShowfloatingButton] = useState(false);
  const location = useLocation();

  const navigate = useNavigate();
  const memberInfoData = useSelector(
    (state) => state.memberInfo.memberInfoData
  );

  useEffect(() => {
    const afterDomain = location.pathname + location.search + location.hash;

    const isLoginPage = location.pathname === "/login";
    const isClubsLoginPage = location.pathname === "/clubs_login";
    const isSaLoginPage = location.pathname === "/sa_login";
    const isHomePage = location.pathname === "/";
    if (!isHomePage && !isSaLoginPage && !isClubsLoginPage && !isLoginPage) {
      seTisShowfloatingButton(true);
    }
    else {
      seTisShowfloatingButton(false);
    }
    if (!isLoginPage && !isClubsLoginPage && !isSaLoginPage) {
      localStorage.setItem("redirect_url", afterDomain || "/");
      console.log("redirect_url:", afterDomain);
    }
  }, [location.pathname, location.search, location.hash]);

  const accessToken = localStorage.getItem("access_token");
  const host = window.location.hostname;
  const index = useMemo(() => {
    if (host === "localhost") {
      return "LocalSALinkUp";
    } else {
      return "SALinkUp";
    }
  }, []);

  // useEffect(()=>{setOpenPopup(true)},[])
  //popup type
  const showNoMemberPopup = openPopup && !memberInfoData;
  const showLinkUpPopup = openPopup && memberInfoData?.member_type === 1;
  const showUpdateInfoPopup =
    openPopup &&
    memberInfoData?.is_editable === 1 &&
    [2, 3].includes(memberInfoData?.member_type);

  useEffect(() => {
    memberInfoData?.popup_type === 1 && updatePopupCount();
    memberInfoData?.popup_type === 2 && updatePopupCount();
  }, [openPopup]);

  useEffect(() => {
    const urlLang = searchParams.get("lang");
    const savedLang = localStorage.getItem("language");

    let targetLang = "hk";

    if (urlLang === "hk" || urlLang === "hk_en") {
      targetLang = urlLang;
      localStorage.setItem("language", targetLang);
    } else if (savedLang === "hk" || savedLang === "hk_en") {
      targetLang = savedLang;
    }

    if (i18n.language !== targetLang) {
      i18n.changeLanguage(targetLang);
      localStorage.setItem("language", targetLang);
    }
  }, [i18n]);

  useEffect(() => {
    document.title = t("global:website_title");
  }, [i18n.language, document.title]);

  useEffect(() => {
    if (!loading) {
      setLoaderVisible(false); // 觸發 PageLoader 淡出動畫
      document.querySelector(".popup-content")?.scrollTo(0, 0); // 一開始popup 係最頂
      const timer = setTimeout(() => {
        setShowLoader(false); // 完全 remove 掉 PageLoader 元件
      }, 1250);
      return () => clearTimeout(timer);
    }
  }, [loading]); // ✅ 改為依賴 loading


  useEffect(() => {
    if (
      location.pathname === "/event_form" &&( searchParams.get("id") == 71)) {
        console.log("87 71")
       
    }
  }, [])

  // 如果event_form 有 code 就唔彈 popup, clubs_login no popup.
  useEffect(() => {
    if (
      location.pathname === "/event_form" &&
      (searchParams.get("code") || searchParams.get("workshop_code"))
    ) {
      setOpenPopup(false);
    }
    else if (location.pathname === "/galaxy_ai_academy" || location.pathname === "/blogs" || location.pathname === "/videos"
      || location.pathname === "/blog_article" || location.pathname === "/inquiry"
      || location.pathname === "/galaxy_ai_academy_landing" || location.pathname === "event_form") {
      setOpenPopup(false);
    }
    else {
      setOpenPopup(true);
    }

    if (location.pathname === "/clubs_login") setOpenPopup(false);
    if (location.pathname === "/sa_login") setOpenPopup(false);

    //2026-03-31 added
    if (location.pathname === "/event_form") setOpenPopup(false);
  }, [memberInfoData?.member_type]);


  // ---- optional: 用 ref 防止 100% 時重複觸發 ----
  const redirectedRef = useRef(false);

  // ---- 只在 showLinkUpPopup = true 時跑 timer ----
  useEffect(() => {
    if (!showLinkUpPopup) return;

    // 打開 popup 先重置
    setRedirectToLinkUpProgress(0);
    redirectedRef.current = false;

    const timer = setInterval(() => {
      setRedirectToLinkUpProgress((old) => {
        const next = Math.min(old + Math.random() * 5, 100);

        if (next === 100 && !redirectedRef.current) {
          redirectedRef.current = true;
          redirectToSamsungLoginPage({
            memberInfoData,
            accessToken,
            index,
            ...(utmId ? { id: utmId } : {}),
          });
        }
        return next;
      });
    }, 100);

    return () => {
      clearInterval(timer);
      setRedirectToLinkUpProgress(0);
      redirectedRef.current = false;
    };
  }, [showLinkUpPopup]); // ✅ 只依賴呢個

  const updateProfile = async () => {
    setIsLoading(true);
    try {
      await editMemberProfile({
        phone: memberInfoData?.country_code + memberInfoData?.mobile,
      });

      toast.success(t("popup:updated_mobile_message"));
      setOpenPopup(false);
    } catch (err) {
      console.error("更新失敗", err);
      toast.error(t("member:update_fail"));
    } finally {
      setIsLoading(false);
    }
  };

  const updatePopupCountStatus = async () => {
    setIsLoading(true);
    try {
      await updatePopupCount();
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <ThemeProvider theme={theme}>
      {isShowfloatingButton && <FloatingBtn />}
      <Box className="App">
        {showNoMemberPopup && (
          <Popup open={openPopup} onClose={() => setOpenPopup(false)}>
            <Box className="notice-popup-container">
              <Box className="notice-icon-container">
                <ErrorIcon className="notice-icon" />
              </Box>
              <Typography className="notice-title">
                <Trans i18nKey="popup:important_noticve" />
              </Typography>
              <Box className="notice-description">
                <Typography
                  dangerouslySetInnerHTML={{
                    __html: t("popup:notice_content"),
                  }}
                />
              </Box>
              <Typography className="notice-sub-title">
                <Trans i18nKey="popup:notice_sup_text_a" />
              </Typography>
              <Box className="notice-table">
                <table className="styled-table">
                  <tr className="table-header">
                    <th>
                      <Typography>
                        <Trans i18nKey="popup:notice_table_header_a_1" />
                      </Typography>
                    </th>
                    <th>
                      <Typography>
                        <Trans i18nKey="popup:notice_table_header_a_2" />
                      </Typography>
                    </th>
                  </tr>
                  <tr className="table-row">
                    <td
                      style={{
                        verticalAlign: "middle",
                      }}
                    >
                      <Typography
                        dangerouslySetInnerHTML={{
                          __html: t("popup:notice_table_content_a_1_1"),
                        }}
                      />
                    </td>
                    <td>
                      <Typography
                        dangerouslySetInnerHTML={{
                          __html: t("popup:notice_table_content_a_1_2"),
                        }}
                      />
                    </td>
                  </tr>
                  <tr className="table-row">
                    <td>
                      <Typography
                        dangerouslySetInnerHTML={{
                          __html: t("popup:notice_table_content_a_2_1"),
                        }}
                      />
                    </td>
                    <td colSpan={2}>
                      <Typography>
                        <Trans i18nKey="popup:notice_table_content_a_2_2" />
                      </Typography>
                    </td>
                  </tr>
                </table>
              </Box>
              <Typography className="notice-sub-title">
                <Trans i18nKey="popup:notice_sup_text_b" />
              </Typography>
              <Box className="notice-table">
                <table className="styled-table">
                  <tr className="table-header">
                    <th>
                      <Typography>
                        <Trans i18nKey="popup:notice_table_header_b_1" />
                      </Typography>
                    </th>
                    <th>
                      <Typography>
                        <Trans i18nKey="popup:notice_table_header_b_2" />
                      </Typography>
                    </th>
                  </tr>
                  <tr className="table-row">
                    <td>
                      <Typography
                        dangerouslySetInnerHTML={{
                          __html: t("popup:notice_table_content_b_1_1"),
                        }}
                      />
                    </td>
                    <td>
                      <Typography
                        dangerouslySetInnerHTML={{
                          __html: t("popup:notice_table_content_b_1_2"),
                        }}
                      />
                    </td>
                  </tr>
                  <tr className="table-row">
                    <td colspan={2}>
                      <Typography
                        dangerouslySetInnerHTML={{
                          __html: t("popup:notice_table_content_b_2_1"),
                        }}
                      />
                    </td>
                  </tr>
                </table>
              </Box>
              <Box className="notice-tnc">
                <Typography
                  dangerouslySetInnerHTML={{
                    __html: t("popup:notice_tnc"),
                  }}
                />
              </Box>
              <Typography className="notice-date">
                <Trans i18nKey="popup:noticve_date" />
              </Typography>
              <Box className="popup-button-container">
                <Button
                  className="loading-button"
                  sx={{ textTransform: "none" }}
                  disableElevation
                  disableRipple
                  onClick={() => {
                    navigate("/member_zone");
                    setOpenPopup(false);
                  }}
                >
                  <Trans i18nKey="popup:notice_go" />
                </Button>
                <Button
                  className="button"
                  sx={{ textTransform: "none" }}
                  disableElevation
                  disableRipple
                  onClick={() => {
                    setOpenPopup(false);
                  }}
                >
                  <Trans i18nKey="popup:later" />
                </Button>
              </Box>
            </Box>
          </Popup>
        )}
        {showLinkUpPopup && (
          <Popup open={openPopup} onClose={() => setOpenPopup(false)}>
            <CancelIcon
              className="close-icon"
              onClick={() => {
                setOpenPopup(false);
              }}
            />
            <Box className="notice-popup-container">
              <Box className="notice-icon-container">
                <img
                  className="notice-logo"
                  src={`${process.env.PUBLIC_URL}/assets/images/global/mobile_logo.png`}
                  alt="logo"
                />
              </Box>
              <Typography className="notice-title-2">
                {memberInfoData?.first_name},<br />
                <Trans i18nKey="popup:after_login_before_link_sa_title" />{" "}
                <LinearProgress
                  variant="determinate"
                  value={redirectToLinkUpProgress}
                  className="custom-progress"
                />
              </Typography>
            </Box>
          </Popup>
        )}
        {(memberInfoData?.popup_type == 1 ||
          memberInfoData?.popup_type == 2) && (
            <Popup open={openPopup} onClose={() => setOpenPopup(false)}>
              <CancelIcon
                className="close-icon"
                onClick={() => {
                  setOpenPopup(false);
                }}
              />
              <Box className="notice-popup-container">
                <Box className="notice-icon-container">
                  <CheckCircleIcon className="success-icon" />
                </Box>
                <Typography className="notice-title">
                  {memberInfoData?.first_name},{" "}
                  <Trans i18nKey="popup:after_login_title" />
                </Typography>{" "}
                <Box className="notice-content">
                  <Typography
                    dangerouslySetInnerHTML={{
                      __html: t("popup:after_login_content_1"),
                    }}
                  />
                </Box>
                <Box className="member-data-field">
                  <Box className="notice-field">
                    <Typography>
                      <Trans i18nKey="popup:email" /> {memberInfoData?.email}
                    </Typography>
                  </Box>

                  <Box className="notice-field">
                    <Typography>
                      <Trans i18nKey="popup:mobile" />{" "}
                      {memberInfoData?.phone ? (
                        <>
                          {memberInfoData?.country_code &&
                            "+" + memberInfoData?.country_code}{" "}
                          {memberInfoData?.mobile}
                        </>
                      ) : (
                        <span className="not-provided">
                          <Trans i18nKey="popup:not_provided" />
                        </span>
                      )}
                    </Typography>
                  </Box>
                </Box>
                <Box className="notice-content">
                  {memberInfoData?.phone ? (
                    <Typography
                      dangerouslySetInnerHTML={{
                        __html: t("popup:after_login_content_1_a"),
                      }}
                    />
                  ) : (
                    <Typography
                      dangerouslySetInnerHTML={{
                        __html: t("popup:after_login_content_1_b"),
                      }}
                    />
                  )}
                </Box>
                <Box className="popup-button-container">
                  {memberInfoData?.phone && (
                    <Button
                      className="loading-button"
                      disableElevation
                      disableRipple
                      onClick={() => {
                        updateProfile();
                      }}
                    >
                      <Trans i18nKey="popup:confirm" />
                    </Button>
                  )}
                  <Button
                    className="loading-button"
                    disableElevation
                    disableRipple
                    onClick={() => {
                      memberInfoData?.is_editable === 1 &&
                        (memberInfoData?.member_type === 2 ||
                          memberInfoData?.member_type === 3) &&
                        navigate("/member_zone");
                      setOpenPopup(false);
                    }}
                  >
                    <Trans i18nKey="popup:update" />
                  </Button>
                </Box>
              </Box>
            </Popup>
          )}

        {showLoader && <PageLoader visible={loaderVisible} />}
        <>
          <ToastContainer
            className="toast"
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
            transition={Bounce}
          />
          <NavigationBar />
          <ScrollToTop />
          <Box className="main-content">
            <Routes>
              <Route index path="/" element={<Home />} />
              <Route path="/galaxy_ai_academy" element={<EventSummaryPage />} />
              <Route path="/galaxy_ai_academy_landing" element={<EventRegistrationLanding />} />
              <Route path="/event_form" element={<EventForm />} />
              {/* <Route path="/video_blog" element={<VideoBlogSummaryPage />} /> */}
              <Route path="/videos" element={<VideoSummaryPage />} />
              <Route path="/blogs" element={<BlogSummaryPage />} />
              <Route path="/blog_article" element={<BlogArticlePage />} />
              <Route path="/reset_password" element={<ResetPassword />} />
              <Route path="/redeem" element={<Redeem />} />
              <Route path="/tnc" element={<TncPage />} />
              <Route path="/faq" element={<FaqPage />} />

              <Route
                element={
                  <RedirectIfAuthenticated redirectTo="/member_zone?section=member_inquiry" />
                }
              >
                <Route path="/inquiry" element={<Inquiry />} />
              </Route>

              <Route element={<RedirectIfAuthenticated />}>
                <Route path="/login" element={<Login />} />
                <Route path="/clubs_login" element={<OnlyClubsLogin />} />
                <Route path="/sa_login" element={<OnlySamsungAccountLogin />} />
                <Route
                  path="/forget_password"
                  element={<ForgetPassword />}
                ></Route>
              </Route>

              {!loading && (
                <Route element={<ProtectedRoute />}>
                  <Route path="/member_zone" element={<MemberZone />} />
                  <Route path="/earn" element={<EarnSDollar />} />
                </Route>
              )}
              <Route
                path="/after_samsung_account_login"
                element={<AfterSamsungAccountLogin />}
              />
              <Route path="/is_linked" element={<IsLinked />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Box>
          <Footer />
        </>
      </Box>
    </ThemeProvider>
  );
};

export default App;
